import exportReportTypes from 'Constants/export-report-formats';

export default [
    exportReportTypes.EXCEL,
    exportReportTypes.PDF
];
